import { render, staticRenderFns } from "./yizhuxiao.vue?vue&type=template&id=ce361c9a&scoped=true"
import script from "./yizhuxiao.vue?vue&type=script&lang=js"
export * from "./yizhuxiao.vue?vue&type=script&lang=js"
import style0 from "./yizhuxiao.vue?vue&type=style&index=0&id=ce361c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce361c9a",
  null
  
)

export default component.exports